<template>
    <v-container fluid align-start ma-0 pa-2 class="epms1020-main container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle" :useBtnList="['btnReceiptRequest', 'btnSubmitQuot']"
                    :unUseBtnList="unUseBtnList" @btnReceiptRequest="btnReceiptRequest" @btnSubmitQuot="btnSubmitQuot">
                    <template v-slot:body>
                        <v-row no-gutters>
                            <v-col cols="3" class="px-1">
                                <i-label :label="'Basic Information : '" />
                            </v-col>
                            <v-col cols="9" align="right" class="pa-1"
                                :style="headerData.receiveYn != null && headerData.receiveYn === 'Y' ? 'display: none;' : ''">
                                <span class="pa-1 subTitle2">[Not yet Received]</span>
                            </v-col>
                        </v-row>
                        <v-row dense class="form-layout">
                            <v-col cols="12" class="pa-0">
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Quotation No</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-row no-gutters class="row__select-no">
                                            <v-col cols="7">
                                                <v-select v-model="selectedQuot" :items="quotList" item-value="quotNo"
                                                    item-text="quotNo" label="Select No" return-object single-line outlined
                                                    dense @change="quotNoChange"></v-select>
                                            </v-col>
                                            <v-col cols="5"  class="pl-2 pt-1 quotNo" >
                                                {{ quotStepGbn }}
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Title</span>
                                    </v-col>
                                    <v-col cols="8">
                                        <v-text-field v-model="headerData.quotTitle" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Start Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.stDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Finish Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.fiDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Recieve Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.receiveDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Submit Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.submitDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Quotation Desc</span>
                                    </v-col>
                                    <v-col cols="9">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <v-textarea value="******************************" auto-grow outlined rows="3"
                                                row-height="20" shaped readonly />
                                        </template>
                                        <template v-else>
                                            <v-textarea v-model="headerData.quotDesc" auto-grow outlined rows="3"
                                                row-height="20" shaped readonly />
                                        </template>
                                    </v-col>
                                    <v-col cols="2" align="center" class="pr-2 pt-1 formHeader">
                                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn">
                                            <div :style="filePath != null && filePath != '' ? '' : 'display:none;'">
                                                <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing"
                                                    @click="fileOpen">View Attached File</span>
                                            </div>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Request Mean</span>
                                    </v-col>
                                    <v-col cols="11">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <v-textarea value="******************************" auto-grow outlined rows="3"
                                                row-height="20" shaped readonly />
                                        </template>
                                        <template v-else>
                                            <v-textarea v-model="headerData.reqMean" auto-grow outlined rows="3"
                                                row-height="20" shaped readonly />
                                        </template>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Final Des</span>
                                    </v-col>
                                    <v-col cols="11">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <v-textarea value="******************************" auto-grow outlined rows="2"
                                                row-height="20" shaped readonly />
                                        </template>
                                        <template v-else>
                                            <v-textarea v-model="headerData.finalDesc" auto-grow outlined rows="2"
                                                row-height="20" shaped readonly />
                                        </template>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Delivery Term</span>
                                    </v-col>
                                    <v-col cols="11">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <v-textarea value="******************************" auto-grow outlined rows="2"
                                                row-height="20" shaped readonly />
                                        </template>
                                        <template v-else>
                                            <v-textarea v-model="headerData.deliTerm" auto-grow outlined rows="2"
                                                row-height="20" shaped readonly />
                                        </template>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Laycan</span>
                                    </v-col>
                                    <v-col cols="11">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <v-textarea value="******************************" auto-grow outlined rows="2"
                                                row-height="20" shaped readonly />
                                        </template>
                                        <template v-else>
                                            <v-textarea v-model="headerData.laycan" auto-grow outlined rows="2"
                                                row-height="20" shaped readonly />
                                        </template>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span justify="center">REMARK</span>
                                    </v-col>
                                    <v-col cols="11">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <v-textarea value="******************************" auto-grow outlined rows="3"
                                                row-height="20" shaped readonly />
                                        </template>
                                        <template v-else>
                                            <v-textarea v-model="headerData.remark" auto-grow outlined rows="3"
                                                row-height="20" shaped readonly />
                                        </template>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Transportation Fee</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <span class="px-3">
                                                ******************************
                                            </span>
                                        </template>
                                        <template v-else>
                                            <v-text-field v-model="headerData.trsAmt" type="text" dense outlined
                                                hide-details="auto" />
                                        </template>
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Other Fee</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <span class="px-3">
                                                ******************************
                                            </span>
                                        </template>
                                        <template v-else>
                                            <v-text-field v-model="headerData.otAmt" type="number" dense outlined
                                                hide-details="auto" />
                                        </template>
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Money Unit</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <span class="px-3">
                                                *****
                                            </span>
                                        </template>
                                        <template v-else>
                                            <v-select v-model="moneyUnit" :items="moneyUnitList" item-value="code"
                                                item-text="codeName" label="Select No" return-object single-line outlined
                                                dense height="32" />
                                        </template>
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>VAT</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                            <span class="px-3">
                                                *****
                                            </span>
                                        </template>
                                        <template v-else>
                                            <v-select v-model="vatAmt" :items="vatAmtList" item-value="code"
                                                item-text="codeName" label="Select No" return-object single-line outlined
                                                dense height="32" />
                                        </template>
                                    </v-col>
                                </v-row>

                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="3" class="px-1">
                                <i-label :label="'File Information : '" />
                            </v-col>                           
                        </v-row>
                        <v-row v-for="row in  2 " :key="'file__row_' + row" no-gutters style="height: 42px;">
                            <v-col v-for="col in  2 " :key="'file__row_' + row + '__col_' + col" cols="6"
                                :style="{ 'border-width': `${row === 1 ? '1px' : '0px'} 1px 1px ${col === 1 ? '1px' : '0px'}`, 'border-style': 'solid', 'border-color': 'gray' }">
                                <template v-if="getFileGbn(getFileIdx(row, col)) === '1'">
                                    <v-row no-gutters>
                                        <span class="subTitle pa-2 pr-0">{{ getFileIdx(row, col) + '. ' }}</span>
                                        <v-col cols="4">
                                            <v-file-input class="pa-0" placeholder="File input"
                                                v-model="fileList[getFileIdx(row, col) - 1].fileName"></v-file-input>
                                        </v-col>
                                        <span class="subTitle pt-2 pl-4">Description :</span>
                                        <v-col cols="full" class="pa-1">
                                            <v-text-field dense outlined hide-details="auto" clearable height="32"
                                                v-model="fileList[getFileIdx(row, col) - 1].fileDesc" />
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="fileGbn1 === '3'">
                                    <v-row no-gutters class="align-center">
                                        <span class="subTitle pa-2">{{ getFileIdx(row, col) + '. ' }}</span>
                                        <a
                                            @click.stop="ftpDownload(fileList[getFileIdx(row, col) - 1].linkPath, fileList[getFileIdx(row, col) - 1].fileDesc)">
                                            {{ fileList[getFileIdx(row, col) - 1].fileDesc }}
                                        </a>
                                    </v-row>
                                </template>
                                <template v-else-if="fileGbn1 === '4'">
                                    <v-row no-gutters>
                                        <span class="subTitle pa-2 pr-0">{{ `${getFileIdx(row, col) + '.'}${fileList[getFileIdx(row, col) - 1].fileDesc ? fileList[getFileIdx(row, col)
                                            - 1].fileDesc: ''}${
                                                fileList[getFileIdx(row, col) - 1].fileName ? '(' +
                                                    fileList[getFileIdx(row, col) - 1].fileName + ')' : ''
                                        } ` }}</span>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getDateFormat, getNumComma, toNum, getCurrentDate } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getSubmitFile, getQuotNoList, getRequestHead, ftpDownload, goReceive } from '@/api/view/hycot/common/common'
import { submitQuot } from '@/api/view/hycot/4/hycot403'

export default {
    name: 'hycot403',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        DxDataGrid,
        DxColumn,
        DxEditing
    },
    data() {
        return {

            menuTitle: this.$route.meta.title,
            selectedQuot: null,
            headerData: {},
            quotStepGbn: '',
            unUseBtnList: [],
            dataList: [],
            quotList: [],
            vatAmtList: [],
            vatAmt: null,
            moneyUnitList: [],
            moneyUnit: null,
            isHVSip: false,
            showPop: false,
            editGbn: '0', // 0, 1, 2
            format: '#,##0.############',
            fileList: [
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
            ],
            fileGbn1: '0',
            fileGbn2: '0',
            fileGbn3: '0',
            fileGbn4: '0',
            filePath: ''
        }
    },
    methods: {
        initData() {
            this.headerData = {
                receiveYn: 'N',
                submitYn: 'N',
                printYn: 'N',
                quotStep: 'C1'
            }
            this.quotNo = ''
            this.quotStepGbn = ''
            this.dataList = []
            this.unUseBtnList = []
            this.vatAmt = this.vatAmtList[0]
            this.moneyUnit = this.moneyUnitList[0]
            this.editGbn = '0'
            this.fileList = [
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
            ]
            this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '0'
        },
        setHVSIp() {
            const logIP = this.$store.state.user.userIp
            const userGrd = this.$store.state.user.userGrd
            const userId = this.$store.state.user.userId

            if (('192.168.46.5' === logIP || '192.168.48.' === logIP.substr(0, 11) || '192.168.50.' === logIP.substr(0, 11) || '192.168.51.' === logIP.substr(0, 11)
                || '192.168.52.' === logIP.substr(0, 11) || '192.168.53.' === logIP.substr(0, 11) || '192.168.54.' === logIP.substr(0, 11)
                || '192.168.55.' === logIP.substr(0, 11) || '192.168.56.' === logIP.substr(0, 11) || '192.168.57.' === logIP.substr(0, 11)
                || '192.168.58.' === logIP.substr(0, 11) || '192.168.61.' === logIP.substr(0, 11) || '192.168.68.' === logIP.substr(0, 11)
                || '192.168.70.' === logIP.substr(0, 11))
                && !'A' === userGrd && !'95935' === userId && !'90263' === userId && !'11951' === userId && !'11246' === userId && !'10403' === userId && !'11272' === userId && !'10252' === userId) {
                this.isHVSip = true;
            }
        },
        async getCmmCd() {
            await getCmChildCode({
                code: '',
                codegr: '',
                prtCode: 'VAT_AMT',
                userFlag: 'Y'
            }).then(res => {
                this.vatAmtList = res.list
                this.vatAmt = this.vatAmtList[0]
            })


            await getCmChildCode({
                code: '',
                codegr: '',
                prtCode: 'MNY_UNIT',
                userFlag: 'Y'
            }).then(res => {
                this.moneyUnitList = res.list
                this.moneyUnit = this.moneyUnitList[0]
            })
        },
        async getQuotNoList() {
            const param = {
                makerCd: this.$store.state.user.makerCd,
                quotStep: 'C',
                quotDiv: 'N'
            }

            await getQuotNoList(param).then(res => {

                const setVal = res.list.find(element => element.quotNo === this.$route.params.quotNo)

                this.quotList = res.list
                this.selectedQuot = setVal
                this.quotNoChange(setVal)
            })
        },
        quotNoChange(e) {            
            if (e) {
                switch (e.quotStep) {
                    case 'C2': this.quotStepGbn = '1st re-Bidding'
                        break
                    case 'C3': this.quotStepGbn = '2nd re-Bidding'
                        break
                    case 'C4': this.quotStepGbn = '3rd re-Bidding'
                        break
                    default: this.quotStepGbn = ''
                        break
                }                
                this.getQuotData()
            }
        },
        async getQuotData() {
            try {
                this.initData()
                this.openLoading('searching')

                const param = {
                    quotNo: this.selectedQuot.quotNo,
                    quotStep: this.selectedQuot.quotStep,
                    makerCd: this.$store.state.user.makerCd,
                    quotDiv: ''
                }

                await getRequestHead(param).then(res => {
                    //console.log('headRes', res)

                    if (res.list.length > 0) {
                       
                         switch (res.list[0].quotStep) {
                            case 'C2': this.quotStepGbn = '1st re-Bidding'
                                break
                            case 'C3': this.quotStepGbn = '2nd re-Bidding'
                                break
                            case 'C4': this.quotStepGbn = '3rd re-Bidding'
                                break
                            default: this.quotStepGbn = ''
                                break
                        }
                        
                        this.headerData = res.list[0]
                        this.filePath = res.list[0].filePath
                        if (!this.headerData.submitYn || this.headerData.submitYn === 'N') {
                            this.editGbn = '0'
                        } else if (!this.headerData.printYn || this.headerData.printYn === 'N') {
                            this.editGbn = '1'
                        } else {
                            this.editGbn = '2'
                        }
                    }
                })

                await getSubmitFile(param).then(res => {
                    // console.log('fileRes', res)

                    for (let i = 0; i < res.list.length; i++) {
                        this.fileList[i].fileName = res.list[i].fileName
                        this.fileList[i].fileDesc = res.list[i].fileDesc
                        this.fileList[i].fileSeq = res.list[i].fileSeq
                        this.fileList[i].linkPath = res.list[i].linkPath
                    }

                    if (!this.headerData.submitYn || this.headerData.submitYn === 'N') {
                        this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '1'
                    } else {
                        for (let i = 0; i < this.fileList.length; i++) {
                            if (!this.fileList[i].fileName) {
                                this[`fileGbn${i + 1}`] = '2'
                                continue
                            }

                            if (!this.headerData.printYn || this.headerData.printYn === 'N') {
                                this[`fileGbn${i + 1}`] = '3'
                                continue
                            }

                            this[`fileGbn${i + 1}`] = '4'
                        }
                    }

                    // console.log('this.fileGbn1', this.fileGbn1)
                    // console.log('this.fileGbn2', this.fileGbn2)
                    // console.log('this.fileGbn3', this.fileGbn3)
                    // console.log('this.fileGbn4', this.fileGbn4)
                })

                this.setBtnList()
            } finally {
                this.endLoading()
            }
        },

        setBtnList() {

            if (this.headerData.receiveYn === 'Y') {
                this.unUseBtnList.push('btnReceiptRequest')
            }

            if (this.headerData.submitYn === 'Y') {
                this.unUseBtnList.push('btnSubmitQuot')
            }
        },

        getFileGbn(gbn) {
            return this['fileGbn' + gbn]
        },
        getFileIdx(row, col) {
            return row * col + (col < row ? row - 1 : 0)
        },

        getDateFormat(date) {
            return getDateFormat(date)
        },
        getNumComma(val) {
            return getNumComma(val)
        },

        btnReceiptRequest() {
            if (this.headerData.receiveYn && this.headerData.receiveYn === 'Y') {
                return
            }

            if (!this.selectedQuot || !this.selectedQuot.quotNo) {
                this.vToastify(this.$t('There is no data for receive the Bidding Request.'), 'warn')
                return
            }

            this.vToastifyPrompt(
                this.$t('Do you want to receive the Bidding Request?'),
                'info',
                current => {
                    this.openLoading('searching')

                    const param = {
                        quotNo: this.selectedQuot.quotNo,
                        makerCd: this.$store.state.user.makerCd
                    }

                    goReceive(param).then(res => {
                        // console.log('res', res)

                        const msg = res.body
                        if (msg === 'OK') {
                            notify(this.$t('Receipt Bidding is completed.'), 'success', 3000)

                            this.quotNoChange(this.selectedQuot)
                        } else {
                            this.vToastify(this.$t(msg), 'warn')
                        }
                    }).catch(error => {
                        this.vToastify(error, 'warn')
                    }).finally(() => {
                        this.endLoading()
                    })
                },
                null,
                true
            )
        },

        fileOpen(e) {
            let file = this.filePath
            
            //this.openLoading('searching')
            // ftpDownload(file)
            //   .finally(() => {
            //     this.endLoading()
            //   })

            ftpDownload(this.filePath);

        },
         ftpDownload(filePath, fileName) {
            this.openLoading()
            ftpDownload(filePath, fileName).finally(() => {
                this.endLoading()
            })
        },
        async btnSubmitQuot() {
            const vm = this

            const hvsIP = this.isHVSip
            const makerCd = this.$store.state.user.makerCd

            if (hvsIP) {
                this.vToastify(this.$t('Warning : You access to HiP System at the HVS Company.<br>You cannot submit the quotation in the HVS.<br>Call IT Department.(2487, 2496, 2497).'), 'warn')
                return
            } else if (!this.selectedQuot || !this.selectedQuot.quotNo) {
                this.vToastify(this.$t('There is no quotation no.'), 'warn')
                return
            } else if (this.headerData.submitYn === 'Y') {
                return
            } else if (this.headerData.receiveYn !== 'Y') {
                this.vToastify(this.$t('Not yet Received'), 'warn')
                return
            } else if (!this.headerData.trsAmt) {
                this.vToastify(this.$t('Please input Transportation Fee!'), 'warn')
                return
            }             

            new Promise(function (resolve, reject) {
               if (vm.vatAmt.code == 0) {
                        vm.vToastifyPrompt(
                            vm.$t('VAT = 0.<br>Ban co muon tiep tuc?'),
                            'info',
                            current => {
                                console.log('vm.fileList', vm.dataList)
                                resolve(true)
                            },
                            current => {
                                resolve(false)
                            },
                            false
                        )
                    } else {
                        resolve(true)
                    }
                 
            }).then(res => {
                if (res) {
                    for (let i = 0; i < vm.fileList.length; i++) {
                        if (vm.fileList[i].fileName && !vm.fileList[i].fileDesc) {
                            vm.vToastify(vm.$t(`Input File${i + 1} description.`), 'warn')
                            return
                        }
                    }
                    vm.vToastifyPrompt(
                        vm.$t('Do you want to submit the Bidding?'),
                        'info',
                        current => {
                            const formData = new FormData()

                            vm.headerData.trsAmt = !vm.headerData.trsAmt ? 0 : vm.headerData.trsAmt
                            vm.headerData.otAmt  = !vm.headerData.otAmt ? 0 : vm.headerData.otAmt
                            vm.headerData.makerCd = makerCd
                            vm.headerData.trsVat = vm.vatAmt.code
                            vm.headerData.moneUnit = vm.moneyUnit.code
                            vm.headerData.userId = vm.$store.state.user.userId
                            vm.headerData.userIp = vm.$store.state.user.userIp
                            formData.append('masterData', JSON.stringify(vm.headerData))
                            formData.append('detailData', JSON.stringify(vm.dataList))

                            for (let i = 0; i < vm.fileList.length; i++) {
                                if (vm.fileList[i].fileName) {
                                    formData.append('files', vm.fileList[i].fileName)
                                    formData.append('fileDescs', vm.fileList[i].fileDesc)
                                }
                            }
                            console.log(vm.headerData)
                            //console.log('masterData', formData.getAll('masterData'))                            
                            // console.log('files', formData.getAll('files'))
                            // console.log('fileDescs', formData.getAll('fileDescs'))

                            vm.openLoading()
                            submitQuot(formData).then(res => {
                                // console.log('submitQuotRes', res)

                                const result = res.body
                                if (result === 'OK') {
                                    vm.quotNoChange(vm.selectedQuot)
                                    notify(vm.$t('Bidding Submit is completed.'), 'success', 3000)
                                } else {
                                    vm.vToastify(vm.$t(result), 'warn')
                                }
                            }).catch(error => {
                                vm.vToastify(error, 'warn')
                            }).finally(() => {
                                vm.endLoading()
                            })
                        },
                        null,
                        false
                    )
                }

            })

        }
    },
    mounted() {
        this.setHVSIp()
        this.getCmmCd()
        this.getQuotNoList()
    }
}
</script>
<style lang="scss" scoped>
$redBtn: #FF0000;

.form-layout::v-deep .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;

    * {
        border: 0px none !important;
    }

    .row:not(.row__select-no) {
        border-width: 0 0 1px 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }

    .col:not(.quotNo) {
        border-width: 0 1px 0 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }
}

.receiptBtn {
    font-weight: bold;
    color: #4980BC;
}

.receiptBtn:hover {
    color: blue;
}

.formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
}

.subTitle {
    font-weight: bold;
    color: black;
}

.subTitle2 {
    font-weight: bold;
    color: red;
}

.quotNo {
    font-weight: bold;
    border: 1px solid gray;
    border-bottom: 0px;
    color: #0000FF;
    font-size: 9pt;
}

::v-deep {

    [role=btnSubmitQuot],
    [role=btnImportFromExcel] {
        :not([disabled=disabled]) {
            .v-btn__content {

                div,
                i {
                    color: #{$redBtn} !important;
                }
            }
        }
    }
}

.allBtn,
.file-link {
    cursor: pointer;
}

.allBtn:hover,
.file-link:hover {
    color: #4980BC;
}
</style>